import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import {
  PagesUploadPreviewFoldersDocument,
  PagesUploadPreviewUpdateCategoryDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export interface PageSidebarProps {
  pageId: number
  category: string | null
  setCategory: (category: string) => void
}

export const PageSidebar = ({ pageId, category, setCategory }: PageSidebarProps) => {
  const [updateCategory, { loading: isLoadingUpdateCategory }] = useMutation(
    PagesUploadPreviewUpdateCategoryDocument,
    {
      extractorFn: (data) => data.handbookPagesMutations.updateHandbookpagesPage,
    }
  )

  const { data, loading: isLoadingFolders, error } = useQuery(PagesUploadPreviewFoldersDocument)
  const categories = data?.handbookPages?.foldersConnection?.nodes.map((folder) => ({
    label: folder.name,
    value: folder.slug,
  }))

  const handleCategoryChange = (value: string) => {
    setCategory(value)
    updateCategory({
      variables: {
        id: pageId,
        folderType: value,
      },
    })
  }

  return (
    <Box
      flexDirection="column"
      flexNoShrink
      gap="s16"
      width="s360"
      paddingX="s16"
      paddingY="s20"
      height="full"
    >
      <Text size="200" weight="medium" color="grey1000">
        {i18n.t('pages.upload_files_modal.preview.sidebar.title')}
      </Text>

      <F0Select
        loading={isLoadingUpdateCategory || isLoadingFolders}
        label={i18n.t('pages.upload_files_modal.preview.sidebar.category_label')}
        onChange={handleCategoryChange}
        options={categories ?? []}
        placeholder={i18n.t('pages.upload_files_modal.preview.sidebar.category_placeholder')}
        value={category ?? ''}
        error={error?.message ?? false}
        size="md"
        status={
          category
            ? undefined
            : {
                type: 'warning',
                message: i18n.t(
                  'pages.upload_files_modal.preview.sidebar.category_required_warning'
                ),
              }
        }
      />
    </Box>
  )
}
